export const STATUS_FILTER_MAPPING = {
  Paid: 'paid',
  Pending: 'unpaid',
  Cancelled: 'cancelled',
} as Record<string, string>;
